import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=d70fceae&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70fceae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70fceae')) {
      api.createRecord('d70fceae', component.options)
    } else {
      api.reload('d70fceae', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=d70fceae&scoped=true&", function () {
      api.rerender('d70fceae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fh6gBCI58yCo/JS/comp/Voucher-Unit.vue"
export default component.exports